import {useEffect} from "react";
import {ThinCloseIcon, ThinTrashIcon} from "../icons/material-icons";
import '../../static/css/templ/remove-modal.css';

export const RemoveModal = (props:{active:boolean,closeHandler:any,title:string,desc:string,onRemove:any}) => {
    useEffect(()=>{
        const isActive = props.active;
        if(isActive){
            document.body.classList.add('body-no-scroll');
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    },[props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active':'')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active':'')}>
                <div className="web-modal-header">
                    <div>
                        <b>{props.title}</b>
                    </div>
                    <button onClick={props.closeHandler}>
                        <ThinCloseIcon/>
                    </button>
                </div>
                <div className="web-modal-body">
                    <div className="calc-modal-remove">
                        <div>
                            <em><ThinTrashIcon/></em>
                            <b>{props.title}</b>
                            <p>{props.desc}</p>
                            <div>
                                <button data-i="0" onClick={props.closeHandler}>
                                    انصراف
                                </button>
                                <button data-i="1" onClick={()=>{
                                    props.onRemove();
                                    props.closeHandler();
                                }}>
                                    حذف شود
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};